import React, { createContext, useContext, useState, useEffect } from 'react';

const FontSizeContext = createContext();

export function useFontSize() {
  return useContext(FontSizeContext);
}

export function FontSizeProvider({ children }) {
  const [fontSize, setFontSize] = useState(() => {
    const stored = localStorage.getItem('fontSize');
    return stored ? parseFloat(stored) : 16;
  });

  useEffect(() => {
    localStorage.setItem('fontSize', fontSize);
    document.documentElement.style.setProperty('--app-font-size', `${fontSize}px`);
  }, [fontSize]);

  return (
    <FontSizeContext.Provider value={{ fontSize, setFontSize }}>
      {children}
    </FontSizeContext.Provider>
  );
}
